import { NgModule }                 from '@angular/core';
import { Routes,
         RouterModule }             from '@angular/router';

import { LoggedInGuard }            from './_guards/logged-in.guard';

//Layouts
import { FullLayoutComponent }      from './layouts/full-layout.component';
import { SimpleLayoutComponent }    from './layouts/simple-layout.component';

export const routes: Routes = [
    {
        path: '',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Leader', 'Administrator','Participant Family', 'Student']
        },
        children: [
            {
                path: '',
                loadChildren: './dashboard/dashboard.module#DashboardModule'
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'dashboard',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Leader', 'Administrator','Participant Family', 'Student']
        },
        children: [
            {
                path: '',
                loadChildren: './dashboard/dashboard.module#DashboardModule'
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'team-dashboard',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Team']
        },
        children: [
            {
                path: '',
                loadChildren: './team-dashboard/team-dashboard.module#TeamDashboardModule'
            }
        ]
        //,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'user-management',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Administrator']
        },
        children: [
            {
                path: '',
                loadChildren: './user-management/user-management.module#UserManagementModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'leader-enroll',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Administrator','Leader']
        },
        children: [
            {
                path: '',
                loadChildren: './leader-enroll/leader-enroll.module#LeaderEnrollModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'leader-management',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Administrator']
        },
        children: [
            {
                path: '',
                loadChildren: './leader-management/leader-management.module#LeaderManagementModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'uploaded-documents',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Administrator']
        },
        children: [
            {
                path: '',
                loadChildren: './uploaded-documents/uploaded-documents.module#UploadedDocumentsModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'student-management',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Leader', 'Administrator']
        },
        children: [
            {
                path: '',
                loadChildren: './student-management/student-management.module#StudentManagementModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'waiver-management',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Administrator']
        },
        children: [
            {
                path: '',
                loadChildren: './waiver-management/waiver-management.module#WaiverManagementModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'my-student',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Participant Family']
        },
        children: [
            {
                path: '',
                loadChildren: './my-student/my-student.module#StudentManagementModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'event-management',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Leader', 'Administrator']
        },
        children: [
            {
                path: '',
                loadChildren: './event-management/event-management.module#EventManagementModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'team-management',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Leader', 'Administrator']
        },
        children: [
            {
                path: '',
                loadChildren: './team-management/team-management.module#TeamManagementModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'seasons-management',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Administrator']
        },
        children: [
            {
                path: '',
                loadChildren: './seasons-management/seasons-management.module#SeasonsManagementModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'my-team',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Leader']
        },
        children: [
            {
                path: '',
                loadChildren: './my-team/my-team.module#MyTeamModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'survey-management',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Administrator']
        },
        children: [
            {
                path: '',
                loadChildren: './survey-management/survey-management.module#SurveyManagementModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'miles-today',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Leader']
        },
        children: [
            {
                path: '',
                loadChildren: './miles-today/miles-today.module#MilesTodayModule',
            }
        ]
        
    },
    {
        path: 'family-miles',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Participant Family']
        },
        children: [
            {
                path: '',
                loadChildren: './family-miles/family-miles.module#FamilyMilesModule',
            }
        ]
        
    },
    {
        path: 'profile',
        component: FullLayoutComponent,
        data: {
            title: 'Profile',
            roles: ['Leader', 'Administrator','Participant Family']
        },
        children: [
            {
                path: '',
                loadChildren: './profile/profile.module#ProfileModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'info',
        component: FullLayoutComponent,
        data: {
            title: 'Information',
            roles: ['Leader']
        },
        children: [
            {
                path: '',
                loadChildren: './info/info.module#InfoModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'help',
        component: FullLayoutComponent,
        data: {
            title: 'Help',
            roles: ['Participant Family', 'Student']
        },
        children: [
            {
                path: '',
                loadChildren: './help/help.module#HelpModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'faq',
        component: FullLayoutComponent,
        data: {
            title: 'FAQ',
            roles: ['Leader']
        },
        children: [
            {
                path: '',
                loadChildren: './faq/faq.module#FaqModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'emergency_procedures',
        component: FullLayoutComponent,
        data: {
            title: 'Emergency Procedures',
            roles: ['Leader']
        },
        children: [
            {
                path: '',
                loadChildren: './emergency/emergency.module#EmergencyModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'settings',
        component: FullLayoutComponent,
        data: {
            title: 'Settings',
            roles: ['Administrator']
        },
        children: [
            {
                path: '',
                loadChildren: './settings/settings.module#SettingsModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'permissions',
        component: FullLayoutComponent,
        data: {
            title: 'Permissions',
            roles: ['Administrator']
        },
        children: [
            {
                path: '',
                loadChildren: './permissions/permissions.module#PermissionsModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'email',
        component: FullLayoutComponent,
        data: {
            title: 'Email Users',
            roles: ['Leader', 'Administrator']
        },
        children: [
            {
                path: '',
                loadChildren: './email/email.module#EmailModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'users',
        component: SimpleLayoutComponent,
        data: {
            title: 'Users'
        },
        children: [
            {
                path: '',
                loadChildren: './users/users.module#UsersModule',
            }
        ]
    },
    {
        path: 'password',
        component: SimpleLayoutComponent,
        data: {
            title: 'Password'
        },
        children: [
            {
                path: '',
                loadChildren: './password/password.module#PasswordModule',
            }
        ]
    },
    {
        path: 'register/:id',
        component: SimpleLayoutComponent,
        data: {
            title: '',
            roles: ['Participant Family']
        },
        children: [
            {
                path: '',
                loadChildren: './register/register.module#RegisterModule',
            }
        ]
        
    },
    {
        path: 'leader-register/:id',
        component: SimpleLayoutComponent,
        data: {
            title: '',
            roles: ['Leader']
        },
        children: [
            {
                path: '',
                loadChildren: './leader-register/leader-register.module#LeaderRegisterModule',
            }
        ]
    },
    {
        path: 'enroll',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Administrator']
        },
        children: [
            {
                path: '',
                loadChildren: './enroll/enroll.module#EnrollModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'feedback',
        component: FullLayoutComponent,
        data: {
            title: 'Feedback',
            roles: ['Leader','Participant Family']
        },
        children: [
            {
                path: '',
                loadChildren: './feedback/feedback.module#FeedbackModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'attach-user',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Administrator']
        },
        children: [
            {
                path: '',
                loadChildren: './attach-user/attach-user.module#AttachUserModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'leader-uploads',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Leader']
        },
        children: [
            {
                path: '',
                loadChildren: './leader-uploads/leader-uploads.module#LeaderUploadsModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'message-history',
        component: FullLayoutComponent,
        data: {
            title: '',
            roles: ['Administrator', 'Leader', 'Student']
        },
        children: [
            {
                path: '',
                loadChildren: './message-history/message-history.module#MessageHistoryModule',
            }
        ]
        ,canActivate: [LoggedInGuard] //comment this out for dev
    },
    {
        path: 'register',
        redirectTo:"users"
    },
    {
        path: 'leader-register',
        redirectTo:"users"
    },
    {
        path: '**', redirectTo:"users"
    }
];

@NgModule({
    imports: [ RouterModule.forRoot(routes) ],
    exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts